import { toast } from "sonner";

function error(message: string) {
  toast.error(message);
}

function success(message: string) {
  toast.success(message);
}

function info(message: string) {
  toast.info(message);
}

const DEFAULT_ACTION_DURATION_MS = 8000;

function ActionToast(props: {
  message: string;
  action: { label: string; onClick: () => void };
  duration: number;
  toastId: string | number;
}) {
  return (
    <div className="relative w-[356px] overflow-hidden rounded-lg border border-concrete-200 bg-white shadow-lg">
      <div className="flex items-center justify-between gap-3 px-4 py-3">
        <p className="text-sm font-medium text-concrete-900">{props.message}</p>
        <button
          type="button"
          className="shrink-0 rounded-md px-2 py-1 text-sm font-semibold text-persian-600 hover:bg-persian-50 hover:text-persian-700"
          onClick={() => {
            props.action.onClick();
            toast.dismiss(props.toastId);
          }}
        >
          {props.action.label}
        </button>
      </div>
      <div className="h-0.5 w-full bg-concrete-100">
        <div
          className="h-full origin-left bg-concrete-400"
          style={{
            animation: `toast-progress ${props.duration}ms linear forwards`,
          }}
        />
      </div>
    </div>
  );
}

function withAction(
  message: string,
  action: { label: string; onClick: () => void },
  options?: { duration?: number },
) {
  const duration = options?.duration ?? DEFAULT_ACTION_DURATION_MS;

  toast.custom(
    (toastId) => (
      <ActionToast
        message={message}
        action={action}
        duration={duration}
        toastId={toastId}
      />
    ),
    { duration },
  );
}

export const toasts = {
  error,
  success,
  info,
  withAction,
};
